import { AlertProps } from '@mui/material';
import { atom } from 'jotai';

export const openConnectAtom = atom(false);

export const snackbarAtom = atom<{
  msg: React.ReactNode;
  open: boolean;
  variant: AlertProps['severity'];
}>({ msg: null, open: false, variant: 'info' });

export const mobileDrawerAtom = atom(false);
